import { array, object, string } from 'yup';

import { validatorConfigsSchema } from './validator-config.schema';
import { validDotPath } from '../../shared/constants/valid-dot-path.constant';
import { arrayUniqueBy } from '../../shared/functions/array-unique-by';
import { IValidationConfig } from '../types/validation-config.interface';

export const validationConfigSchema = object<IValidationConfig>({
  targetPath: string().trim().required().matches(validDotPath),
  validators: validatorConfigsSchema,
});

export const validationConfigsSchema = array<IValidationConfig>()
  .required()
  .test({ name: 'targetPath', message: 'targetPath is not unique', test: arrayUniqueBy('targetPath') })
  .of(validationConfigSchema.required());
